(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["HubSpot"] = factory(require("axios"));
	else
		root["HubSpot"] = factory(root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return 